module.exports = __webpack_public_path__ + "static/media/ArrowLeft.3f9b617e.svg";